import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./MorePage.css";

export function MorePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="more-page">
      <h1>More</h1>

      <div className="user-card">
        <div className="user-avatar">
          {user?.name?.charAt(0).toUpperCase() || "?"}
        </div>
        <div className="user-info">
          <h2>{user?.name || "User"}</h2>
          <p>{user?.email}</p>
        </div>
      </div>

      <div className="menu-section">
        <button className="menu-item" onClick={() => navigate("/messages")}>
          <span className="menu-icon">💬</span>
          <span className="menu-label">Messages</span>
          <span className="menu-arrow">›</span>
        </button>

        <button className="menu-item" onClick={() => navigate("/bookings")}>
          <span className="menu-icon">📅</span>
          <span className="menu-label">Bookings</span>
          <span className="menu-arrow">›</span>
        </button>

        <button className="menu-item" onClick={() => navigate("/plans")}>
          <span className="menu-icon">📋</span>
          <span className="menu-label">Plans</span>
          <span className="menu-arrow">›</span>
        </button>

        <button className="menu-item" onClick={() => navigate("/shop")}>
          <span className="menu-icon">🛒</span>
          <span className="menu-label">Shop</span>
          <span className="menu-arrow">›</span>
        </button>

        <button className="menu-item" onClick={() => navigate("/import")}>
          <span className="menu-icon">📥</span>
          <span className="menu-label">Import Activity</span>
          <span className="menu-arrow">›</span>
        </button>

        <button className="menu-item" onClick={() => navigate("/pricing")}>
          <span className="menu-icon">💳</span>
          <span className="menu-label">Subscription</span>
          <span className="menu-arrow">›</span>
        </button>

        <button className="menu-item" onClick={() => navigate("/settings")}>
          <span className="menu-icon">⚙️</span>
          <span className="menu-label">Settings</span>
          <span className="menu-arrow">›</span>
        </button>
      </div>

      <button className="logout-button" onClick={handleLogout}>
        Sign Out
      </button>
    </div>
  );
}
